import { Stack, Typography } from '@mui/material';
import React from 'react';
import { ReactComponent as ArrowRightIcon } from 'new/components/icons/fi-rr-arrow-small-right.svg';
import nexsetIcon from 'new/components/icons/nexset.png';
import { steps } from './stepsConfig';
import styles from './PipelinesEmptyListGuide.module.scss';

const GuideListSteps = () => {
  return (
    <div className={styles.stepsContainer}>
      {steps.map((step, index) => (
        <div key={step.number} className={styles.stepWrapper}>
          <div className={styles.stepItem}>
            <div className={styles.stepCircle}>
              {step.number === 2 ? (
                <img src={nexsetIcon} alt="Nexset" className={styles.nexsetIcon} />
              ) : (
                step.number
              )}
            </div>
            <Stack gap="4px">
              <Typography variant="bodyDefault" className={styles.stepTitle}>
                {step.title}
              </Typography>
              <Typography variant="bodySmall" className={styles.stepDescription}>
                {step.description}
              </Typography>
            </Stack>
          </div>
          {index < steps.length - 1 && (
            <div className={styles.arrow}>
              <ArrowRightIcon />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default GuideListSteps;
